/**
 * @generated SignedSource<<fd016d511d714335004dc09f6eb808ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSubmissionFailureModal_ContentSubmissionFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ShowAnswerButton_ContentSubmissionFragment">;
  readonly " $fragmentType": "ContentSubmissionFailureModal_ContentSubmissionFragment";
};
export type ContentSubmissionFailureModal_ContentSubmissionFragment$key = {
  readonly " $data"?: ContentSubmissionFailureModal_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionFailureModal_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentSubmissionFailureModal_ContentSubmissionFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShowAnswerButton_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "3fed300fc256ee46664b6e0e57ac1e9b";

export default node;
